// EPOD Screen - POD tab visibility / default view resolver.
//
// The authoritative configuration now lives in app_configurations (service_name:'epod_pod_upload',
// section pod_tabs, source:'node') - fetched by epodScreen.js via POST /billing/epodPodTabsOptions and passed into
// resolvePodTabsConfig() below. This file no longer OWNS any business values itself (no
// hardcoded CUSTOMER/TRANSPORTER overrides) - it is purely the resolution function, kept here so
// the actual visible-tabs/default-tab logic has exactly one source of truth regardless of how many
// places in epodScreen.js need the answer (the tab buttons, the Total tile, loadTrips' initial
// view), per that task's own explicit "do not scatter configuration checks" instruction.
//
// SAFE_FALLBACK_CONFIG is deliberately generic (== today's original, pre-config-driven behavior
// for every user_type) and is used ONLY when the DB config hasn't been fetched yet or the fetch
// fails - it must never itself encode a business decision like "CUSTOMER defaults to total", since
// that would let a stale/unreachable frontend fallback silently override a valid DB configuration.
const SAFE_FALLBACK_CONFIG = {
    default_tab: 'pending',
    tabs: {
        pending: { enabled: true },
        closed: { enabled: true },
        invalid_docket: { enabled: true },
    },
    user_type_overrides: {},
};

// Never throws, never returns an unavailable tab as the default - config missing/partial always
// degrades to the safe fallback rather than crashing the screen.
function resolvePodTabsConfig(userType, config) {
    var cfg = (config && typeof config === 'object') ? config : SAFE_FALLBACK_CONFIG;
    var baseTabs = Object.assign({}, SAFE_FALLBACK_CONFIG.tabs, cfg.tabs || {});
    var override = (userType && cfg.user_type_overrides && cfg.user_type_overrides[userType]) || null;
    var overrideTabs = (override && override.tabs) || {};

    function tabEnabled(key) {
        if (overrideTabs[key] && typeof overrideTabs[key] === 'object') return overrideTabs[key].enabled !== false;
        var base = baseTabs[key];
        return !base || base.enabled !== false;
    }

    var resolved = {
        tabs: {
            pending: { enabled: tabEnabled('pending') },
            closed: { enabled: tabEnabled('closed') },
            invalid_docket: { enabled: tabEnabled('invalid_docket') },
        },
    };

    var requestedDefault = (override && override.default_tab) || cfg.default_tab || SAFE_FALLBACK_CONFIG.default_tab;
    // "total" is always available (never a hideable tab) - any other value must resolve to an
    // enabled tab, or fall back to "total" rather than ever selecting a hidden one.
    resolved.default_tab = (requestedDefault === 'total' || (resolved.tabs[requestedDefault] && resolved.tabs[requestedDefault].enabled))
        ? requestedDefault
        : 'total';

    return resolved;
}

module.exports = { resolvePodTabsConfig, SAFE_FALLBACK_CONFIG };
